import React from "react";
import i18n from "i18next";
import InteractiveItemBox from "./InteractiveItemBox";

/* eslint-disable react/prop-types */

/**
 * InteractiveItem — backend'in ürettiği oynanabilir aktiviteyi gösteren plugin.
 *
 * Değerlendirme Öğeleri sekmesindeki "İnteraktif Öğe (AI)" kartından çıkan
 * her şey bu tek plugin'dir: çevrilen kartlar da, hafıza oyunu da, hotspot
 * avı da, zaman çizelgesi de. Plugin'in hangi aktivite olduğundan HABERİ YOK
 * — tipi `state.typeId` taşır, aktiviteyi `state.htmlUrl`'deki doküman çizer,
 * içeriği `state.item` tutar. Yirmi dördüncü aktivite tipi eklemek bu dosyaya
 * hiçbir şey yazmaz.
 *
 * ──────────────────────────────────────────────────────────────────────────
 * İKİ PARÇA: VERİ STATE'TE, KOD BLOB'DA
 * ──────────────────────────────────────────────────────────────────────────
 * `state.item` aktivitenin verisidir — kartlar, çiftler, sorular ve cevap
 * anahtarı. Düzenle ekranı bunu değiştirir, plugin yeni veriyi iframe'e
 * postMessage ile yollar, widget anında kendini yeniden çizer. Model
 * çağrılmaz, kredi harcanmaz, saniyeler değil milisaniyeler sürer.
 *
 * `state.htmlUrl` ise kodun durduğu doküman. Onlarca kilobayt olduğu için
 * state'e gömülmez: `exportedState` zaten 50 MB'a dayanıyor ve state'e gömülen
 * bir doküman her otomatik kayıtta kopyalanır.
 *
 * ──────────────────────────────────────────────────────────────────────────
 * NEDEN category: "evaluation"
 * ──────────────────────────────────────────────────────────────────────────
 * Aktivitelerin çoğu puanlı ve puanın kursa işlemesinin tek yolu bu: bu
 * kategorideki kutular `exercises{}` kaydı açar, Score / GradeComponent
 * zincirine girer, LMS raporunda görünür.
 *
 * PUANSIZ tipler (çevrilen kartlar, zaman çizelgesi, diyagram) de aynı
 * plugin — ama onların kutusu eklenirken `ids.config` BİLEREK geçilmez, bu
 * yüzden egzersiz kaydı hiç açılmaz. Açılsaydı, ağırlığı sıfır olsa bile
 * eğitimin "kaç soru doğru" paydasında görünür ve öğrenci hiç cevaplamadığı
 * bir şeyden eksik alırdı. Bkz. EditorApp'teki ekleme yolu.
 */
export function InteractiveItem(base) {
  return {
    getConfig() {
      return {
        name: "InteractiveItem",
        displayName: i18n.t("InteractiveItem.PluginName", {
          defaultValue: "İnteraktif Öğe",
        }),
        category: "evaluation",
        icon: "extension",
        flavor: "react",
        needsConfigModal: false,
        needsTextEdition: false,
        isComplex: false,
        // Aktiviteler yer ister — sürüklenen kartlar, iki sütun, bir diyagram.
        // Yine de tam kadraj değil: sahnede genelde bir başlık da vardır ve
        // yazarın kenardan tutup büyütmesi tek hareket.
        initialWidth: "88%",
        initialHeight: "80%",
        initialWidthSlide: "88%",
        initialHeightSlide: "80%",
        // Egzersiz kaydı açıldığında kullanılan başlangıç değerleri. Gerçek
        // karşılaştırmayı aşağıdaki checkAnswer yapar; bunlar yalnızca yer
        // tutucu.
        defaultCorrectAnswer: true,
        defaultCurrentAnswer: false,
      };
    },

    getToolbar() {
      // Burada element element düzenlenecek bir şey yok: aktivitenin görünümü
      // üretilmiş koddur, içeriği ise kendi Düzenle ekranında düzenlenir.
      return { main: { __name: "InteractiveItem", accordions: {} } };
    },

    getInitialState() {
      return {
        htmlUrl: "",
        // Ham kaynağın blob adı — "AI ile düzenle" bunu sunucuya geri yollar.
        // Boş olan bir kutu (bu özellikten önce üretilmiş) AI ile
        // düzenlenemez; ekran bunu söyler ve yeni üretim önerir.
        sourceBlobName: "",
        item: null,
        typeId: "",
        typeLabel: "",
        shape: "",
        scored: false,
        label: "",
        model: "",
        version: 1,
      };
    },

    /**
     * Puanlama.
     *
     * GradeComponent her egzersiz için önce plugin'in `checkAnswer`'ını arar
     * ve bulamazsa `currentAnswer === correctAnswer` karşılaştırması yapar —
     * ki bizim cevabımız bir nesne olduğu için o karşılaştırma HER ZAMAN
     * yanlış döner. Bu fonksiyon o yüzden var.
     *
     * Dönen değer 0..1 arası bir ORAN olabilir: GradeComponent kesirli dönüşü
     * kısmi puan olarak işler (ağırlık × oran) ve yalnızca tam 1 olanı "doğru
     * cevap" sayar. Yani altı çiftin dördünü eşleştiren öğrenci puanının
     * üçte ikisini alır, ama "doğru cevapladı" sayılmaz — geçme barajı ve
     * "doğru cevaplanana kadar bekle" davranışı için doğru olan bu.
     */
    checkAnswer(current) {
      if (!current || typeof current !== "object") return false;
      const total = Number(current.total) || 0;
      const correct = Number(current.correct) || 0;
      if (total <= 0) return false;
      return Math.max(0, Math.min(1, correct / total));
    },

    getRenderTemplate(state, props) {
      const safeProps = props || {};
      const boxId = safeProps.id || null;
      return (
        <InteractiveItemBox
          state={state}
          boxId={boxId}
          visor={safeProps.visor === true}
          selected={!!boxId && safeProps.boxSelected === boxId}
          pluginProps={safeProps}
        />
      );
    },
  };
}
